<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>Importer des empreintes via fichier Excel</h2>

        <b-col cols="10" class="mb-4">
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-marches"
                                  :label=libelles.marche label-for="input-marches"
                                  v-if="isAdmin">
                        <AutocompleteCustom
                                id="input-marcheIds"
                                :items="marcheIdsItems"
                                v-model="marcheId"
                                @search="onMarcheSearch"
                                :placeholder=libelles.allMarches
                                :clear=ligneId
                        >
                        </AutocompleteCustom>
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group id="input-group-lignes"
                                  :label=libelles.ligne label-for="input-lignes"
                                  v-if="isAdmin">
                        <b-form-select
                                id="input-lignes"
                                v-model="ligneId"
                                :options="lignes"
                                @change="marcheId = null"
                                required>
                            <template v-slot:first>
                                <b-form-select-option :value="null">
                                    {{libelles.allLines}}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group
                            id="input-group-annee"
                            label-for="input-annee"
                            label="Année">
                        <b-form-select
                                id="input-annee"
                                v-model="annee"
                                :options="annees"
                                @change="onAnneeChange">
                            <template v-slot:first>
                                <b-form-select-option :value="null">
                                    Sélectionner l'année
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group id="input-group-dc4"
                                  :label=empreinteEco.libelleDC4 label-for="input-dc4">
                        <b-form-select
                                id="input-dc4"
                                v-model="dc4"
                                required>
                            <b-form-select-option :value="null">
                                Tous
                            </b-form-select-option>
                            <b-form-select-option :value="true">
                                Oui
                            </b-form-select-option>
                            <b-form-select-option :value="false">
                                Non
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="1" class="mt-4">
                    <b-button v-if="(marcheId && !isAdmin) || isAdmin"
                              type="button" variant="success" @click="exporter">{{libelles.exporter}}
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="mt-1">
                <b-col cols="11">
                    <b-form-file
                            v-model="importFile"
                            placeholder="Choisir un fichier pour import"
                            drop-placeholder="Déposer le fichier ici"
                            browse-text="Importer un fichier"
                            accept=".xlsx"
                    ></b-form-file>
                    <div>
                        Une fois que vous avez mis à jour vos données dans le template Excel, vous pouvez le joindre
                        ci-dessus
                        avant d'importer les données.
                    </div>
                </b-col>
                <b-col cols="1">
                    <b-button type="button" variant="success" @click="importer" :disabled="!importFile">
                        {{libelles.importer}}
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="mt-3 typo-warning" v-if="showRapportErreurTxt">
                Le fichier n'a pas pu être importé, veuillez corriger votre fichier selon le rapport d'erreur avant de
                l'importer de nouveau.
            </b-row>

        </b-col>

        <h3>Liste des imports</h3>
        <TaskList :tasks="tasks" />
    </div>
</template>

<script>

  import EmpreinteEconomiqueStore from "../../stores/EmpreinteEconomiqueStore";
  import AlertStore from "../../stores/AlertStore";
  import MarcheStore from "../../stores/MarcheStore";
  import LigneStore from "../../stores/LigneStore";
  import SessionStore from '@/stores/SessionStore'
  import hasPermission from "../../filters/hasPermission";
  import FileUtil from "../../utils/fileUtil";
  import {EventBus} from '@/event-bus'
  import EmpreinteEconomiqueDto from "../../dtos/EmpreinteEconomiqueDto";
  import {libelles, empreinteEco} from '../../constants/libelles';
  import AutocompleteCustom from "../../components/AutocompleteCustom";
  import moment from "moment";
  import {momentToDate} from "../../utils/dateUtil";
  import TaskList from "@/components/ImporterEmpreinte/TaskList.vue";

  export default {
    components: {
      TaskList,
      AutocompleteCustom,
    },
    data() {
      return {
        sessionStoreState: SessionStore.state,
        marcheId: null,
        ligneId: null,
        marches: [],
        lignes: [],
        tasks: [],
        importFile: null,
        showRapportErreurTxt: false,
        dc4: null,
        libelles: libelles,
        empreinteEco: empreinteEco,
        marcheIdsItems: [],
        annee: null,
        annees: [],
        interval: null
      }
    },
    computed: {
      isAdmin() {
        return hasPermission(["ADMINISTRATEUR", "CORRESPONDANT_EMPREINTE_ADMINISTRATEUR"]) && !this.sessionStoreState.marches.length;
      },
    },
    watch: {
      marcheId(newMarcheId) {
        this.onMarcheSearch(newMarcheId, true);
      },
      tasks(tasks) {
        if (this.interval !== null && tasks.find((task) => task.status === 'IN_PROGRESS') === undefined) {
          clearInterval(this.interval);
          this.interval = null;
          return
        }

        if (this.interval === null && tasks.find((task) => task.status === 'IN_PROGRESS') !== undefined) {
          this.interval = setInterval(() => {
            this.fetchTasks()
          }, 5_000);
        }
      },
      ligneId(newLigneId) {
        if (newLigneId) {
          this.marcheId = null;
        }
        this.onMarcheSearch();
      },
    },
    mounted() {
      this.fetchTasks()
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i >= 2010; i--) {
        this.annees.push(i);
      }
      if (this.isAdmin) {
        MarcheStore.getAll().then(marches => {
          this.marches = marches.map(marche => {
            return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
          });
          this.marcheIdsItems = this.marches;
        });
        LigneStore.getAll().then(
            response => this.lignes = response.map(value => {
              return {text: value.libelleLong, value: value.id};
            })
        );
      }
      if (!this.isAdmin) {
        this.marcheId = this.sessionStoreState.marche.id;
        EventBus.$on('NavBar-marcheChange', () => {
          this.marcheId = this.sessionStoreState.marche.id;
        });
      }
    },
    beforeDestroy() {
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }

      if (!this.isAdmin) {
        EventBus.$off('NavBar-marcheChange');
      }
    },
    methods: {
      fetchTasks() {
        EmpreinteEconomiqueStore.getTasks().then((res) => {
          this.tasks = res;
        })
      },
      onAnneeChange(annee) {
        if (annee) {
          AlertStore.pushWarning("Attention, les données que vous souhaitez télécharger sont filtrées. Seules les entreprises dont le dernier montant versé l'a été pendant l'année sélectionnée seront affichées.");
        }
      },
      exporter() {
        const empreinte = new EmpreinteEconomiqueDto();
        empreinte.statut = ['VALIDE', 'ARCHIVEE'];
        empreinte.dc4 = this.dc4;
        if (this.annee) {
          const momentDebut = moment({ year: this.annee, month: 0, day: 1});
          const momentFin = moment(momentDebut).add(1, 'y').subtract(1, 's');
          empreinte.dateDebut = momentToDate(momentDebut);
          empreinte.dateFin = momentToDate(momentFin);
        }
        if (this.marcheId) {
          empreinte.marcheId = this.marcheId;
        }
        if (this.ligneId) {
          empreinte.ligneId = this.ligneId;
        }
        EmpreinteEconomiqueStore.export(empreinte).then(
            result => {
              FileUtil.downloadFile(result.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf8;');
            },
            error => AlertStore.pushError(error.response.data.message)
        );
      },
      importer() {
        this.showRapportErreurTxt = false;
        EmpreinteEconomiqueStore.importExcel(this.importFile).then(
            result => {
              if (result.status === 204) {
                AlertStore.pushInfo("L'import a été lancé.");
                this.fetchTasks()
              }
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      onMarcheSearch(marche, isId) {
        if (marche) {
          this.ligneId = null;
        }
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marches)
      }
    }
  }
</script>

